import React, { useEffect, useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faEye, faChevronDown, faChevronUp, faUpload, faImage } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './ProductosData.css'
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import baseURL from '../../url';
import NewProduct from '../NewProduct/NewProduct';
import { adminFetch } from '../../../utils/api';
import moneda from '../../moneda';
import { Link as Anchor } from "react-router-dom";
import ImportarProductos from './ImportarProductos/ImportarProductos';
import { compressImageToWebP } from '../../../utils/imageCompression';

function ImageWithSkeleton({ src, alt }) {
    const [loaded, setLoaded] = useState(false);

    // Si no hay imagen, mostrar el texto sin skeleton
    if (!src) {
        return <span className='imgNonetd'>Sin imagen</span>;
    }

    return (
        <div className={`img-wrapper ${loaded ? 'img-loaded' : 'img-loading'}`}>
            {!loaded && <span className="img-skeleton" />}
            <img
                src={src}
                alt={alt}
                loading="lazy"
                decoding="async"
                onLoad={() => setLoaded(true)}
                onError={() => setLoaded(true)}
            />
        </div>
    );
}
export default function ProductosData() {
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalVisible, setModalVisible] = useState(false);
    const [nuevoTitulo, setNuevoTitulo] = useState('');
    const [nuevaDescripcion, setNuevaDescripcion] = useState('');
    const [nuevoPrecio, setNuevoPrecio] = useState('');
    const [nuevoPrecioAnterior, setNuevoPrecioAnterior] = useState(0);
    const [nuevaCategoria, setNuevaCategoria] = useState('');
    const [producto, setProducto] = useState({});
    const [modalImagenVisible, setModalImagenVisible] = useState(false);
    const [imagenSeleccionada, setImagenSeleccionada] = useState('');
    const [filtroId, setFiltroId] = useState('');
    const [filtroTitulo, setFiltroTitulo] = useState('');
    const [filtroCategoria, setFiltroCategoria] = useState('');
    const [filtroCategoria2, setFiltroCategoria2] = useState('');
    const [ordenInvertido, setOrdenInvertido] = useState(false);
    const [imagenPreview, setImagenPreview] = useState(null);
    const [imagenPreview2, setImagenPreview2] = useState(null);
    const [imagenPreview3, setImagenPreview3] = useState(null);
    const [imagenPreview4, setImagenPreview4] = useState(null);
    const [nuevaImagen, setNuevaImagen] = useState(null);
    const [nuevaImagen2, setNuevaImagen2] = useState(null);
    const [nuevaImagen3, setNuevaImagen3] = useState(null);
    const [nuevaImagen4, setNuevaImagen4] = useState(null);
    
    // Refs para inputs de archivo
    const fileInputRef1 = useRef(null);
    const fileInputRef2 = useRef(null);
    const fileInputRef3 = useRef(null);
    const fileInputRef4 = useRef(null);
    const [selectedSection, setSelectedSection] = useState('texto');
    const [nuevoEsAccesorio, setNuevoEsAccesorio] = useState('');
    const [nuevoMasVendido, setNuevoMasVendido] = useState('');
    const [nuevoVisible, setNuevoVisible] = useState('1');
    const [categorias, setCategoras] = useState([]);
    const [item1, setItem1] = useState('');
    const [item2, setItem2] = useState('');
    const [item3, setItem3] = useState('');
    const [item4, setItem4] = useState('');
    const [item5, setItem5] = useState('');
    const [stockItem1, setStockItem1] = useState(0);
    const [stockItem2, setStockItem2] = useState(0);
    const [stockItem3, setStockItem3] = useState(0);
    const [stockItem4, setStockItem4] = useState(0);
    const [stockItem5, setStockItem5] = useState(0);
    const [modulo, setNuevoModulo] = useState('');
    const [nivel, setNuevoNivel] = useState('');
    const [viewAllSizes, setViewAllSizes] = useState(null);
    const [errores, setErrores] = useState({});
    
    // Estados para importar productos
    const [modalImportacionVisible, setModalImportacionVisible] = useState(false);
    
    // Estados para progress bar de exportación
    const [exportProgress, setExportProgress] = useState(0);
    const [isExporting, setIsExporting] = useState(false);
    const [exportTotal, setExportTotal] = useState(0);

    // Estado para la página actual
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10); // Cantidad de productos por página

    // Calcular índices para los productos de la página actual
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    // Cambiar página
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const cerrarModalImagen = () => {
        setModalImagenVisible(false);
    };
    const abrirModalImagenSeleccionada = (imagen) => {
        setImagenSeleccionada(imagen);
        setModalImagenVisible(true);
    };


    useEffect(() => {
        cargarProductos();

    }, [filtroCategoria]);

    useEffect(() => {
        // Actualiza el valor del select cuando cambia el estado nuevoEstado
        setNuevoTitulo(producto.titulo || '');
        setNuevaDescripcion(producto.descripcion || '');
        setNuevoPrecio(producto.precio || '');
        setNuevoEsAccesorio(producto.esAccesorio || '');
        setNuevoMasVendido(producto.masVendido || '');
        setNuevoVisible(producto.visible !== undefined ? producto.visible : '1');
        setNuevaCategoria(producto.idCategoria || '');
        setItem1(producto.item1 || '');
        setItem2(producto.item2 || '');
        setItem3(producto.item3 || '');
        setItem4(producto.item4 || '');
        setItem5(producto.item5 || '');
        setNuevoPrecioAnterior(producto.precioAnterior || '');
        setStockItem1(producto.stockItem1 || 0);
        setStockItem2(producto.stockItem2 || 0);
        setStockItem3(producto.stockItem3 || 0);
        setStockItem4(producto.stockItem4 || 0);
        setStockItem5(producto.stockItem5 || 0);
        setNuevoModulo(producto.modulo || '');
        setNuevoNivel(producto.nivel || '');
    }, [producto]);

    const cargarProductos = () => {
        setLoading(true);
        adminFetch(`${baseURL}/api/admin/productos`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (filtroCategoria !== '') {
                    setProductos(data.productos.filter(producto => (producto.idCategoria == filtroCategoria)) || []);
                } else {
                    setProductos(data.productos || []);
                }
            })
            .catch(error => console.error('Error al cargar productos:', error))
            .finally(() => setLoading(false));
    };

    const eliminarProducto = (idProducto) => {
        // Reemplaza el window.confirm con SweetAlert2
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                adminFetch(`${baseURL}/api/admin/productos/${idProducto}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );
                        cargarProductos();
                    })
                    .catch(error => {
                        console.error('Error al eliminar la Producto:', error);
                        toast.error(error);
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setProducto(item);
        setNuevoTitulo(item.titulo);
        setNuevaDescripcion(item.descripcion);
        setNuevoPrecio(item.precio);
        setNuevaCategoria(item.idCategoria);
        setModalVisible(true);
        setNuevoModulo(item.modulo || '');
        setNuevoNivel(item.nivel || '');
        setNuevoEsAccesorio(item.esAccesorio || '');
        setNuevoMasVendido(item.masVendido || '');
        setNuevoVisible(item.visible !== undefined ? item.visible : '1');
        setViewAllSizes(item.esAccesorio == 'si' ? false : true);
        setErrores({}); // Limpiar errores al abrir el modal
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const productosFiltrados = productos.filter(item => {
        const idMatch = item.idProducto.toString().includes(filtroId);
        const tituloMatch = !filtroTitulo || item.titulo.includes(filtroTitulo);
        const categoriaMatch = item.idCategoria.toString().includes(filtroCategoria);
        const categoriasMatch = !filtroCategoria2 || item.categoria.includes(filtroCategoria2);
        return idMatch && tituloMatch && categoriaMatch && categoriasMatch;
    });

    const currentItems = productosFiltrados.slice(indexOfFirstItem, indexOfLastItem);

    const descargarExcel = () => {
        const data = productosFiltrados.map(item => ({
            idProducto: item.idProducto,
            titulo: item.titulo,
            descripcion: item.descripcion,
            precio: item.precio,
            precioAnterior: item.precioAnterior || '',
            categoria: item.categoria || '',
            masVendido: item.masVendido || 'No',
            'Inventario Ch': item.stockItem1 || 0,
            'Inventario M': item.stockItem2 || 0,
            'Inventario G': item.stockItem3 || 0,
            'Inventario Xg': item.stockItem4 || 0,
            'Inventario Xxg': item.stockItem5 || 0,
            nivel: item.nivel || '',
            modulo: item.modulo || '',
            esAccesorio: item.esAccesorio || 'No',
            orden: item.orden || ''
        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Productos');
        XLSX.writeFile(wb, 'productos.xlsx');
    };

    async function getBase64ImageFromUrl(url) {
        return await fetch(url)
            .then(response => response.blob())
            .then(blob => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    // Crear una imagen para obtener dimensiones
                    const img = new Image();
                    img.onload = () => {
                        resolve({
                            dataURL: reader.result,
                            width: img.width,
                            height: img.height
                        });
                    };
                    img.onerror = reject;
                    img.src = reader.result;
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            }));
    }

    const descargarPDF = () => {
        const pdf = new jsPDF({ orientation: 'landscape' });
        const titulo = "Lista de Productos";
        const fecha = `Fecha de reporte: ${new Date().toISOString().split("T")[0]}`;

        // Agregar título y fecha
        pdf.text(titulo, 10, 10);

        const pageWidth = pdf.internal.pageSize.getWidth();
        const fechaWidth = pdf.getTextWidth(fecha);
        const fechaX = pageWidth - fechaWidth - 10;
        pdf.text(fecha, fechaX, 10);

        // Definir las columnas para la tabla, incluyendo "Categoría" y "Total Prendas"
        const columns = [
            { title: "Id", dataKey: "idProducto" },
            { title: "Imagen", dataKey: "imagen" },
            { title: "Titulo", dataKey: "titulo" },
            { title: "Descripción", dataKey: "descripcion" },
            { title: "Precio", dataKey: "precio" },
            { title: "Categoría", dataKey: "categoria" },
            { title: "Fecha", dataKey: "createdAt" },
            { title: "Ch", dataKey: "stockItem1" },
            { title: "M", dataKey: "stockItem2" },
            { title: "G", dataKey: "stockItem3" },
            { title: "Xg", dataKey: "stockItem4" },
            { title: "Xxg", dataKey: "stockItem5" },
            { title: "Total", dataKey: "totalPrendas" },
            { title: "Modulo", dataKey: "modulo" },
            { title: "Nivel", dataKey: "nivel" },
        ];

        // Procesar datos: sumatoria por fila
        const data = productosFiltrados.map((item) => {
            const total =
                Number(item.stockItem1 || 0) +
                Number(item.stockItem2 || 0) +
                Number(item.stockItem3 || 0) +
                Number(item.stockItem4 || 0) +
                Number(item.stockItem5 || 0);

            return {
                idProducto: item.idProducto,
                imagen: '',
                titulo: item.titulo.slice(0, 20),
                descripcion: item.descripcion.slice(0, 20),
                precio: `$${item.precio}`,
                categoria: item.categoria || "-", // Se asegura tener siempre una categoría válida
                createdAt: item.createdAt.split(" ")[0],
                stockItem1: item.stockItem1,
                stockItem2: item.stockItem2,
                stockItem3: item.stockItem3,
                stockItem4: item.stockItem4,
                stockItem5: item.stockItem5,
                totalPrendas: total,
                modulo: item.modulo || "-",
                nivel: item.nivel || "-",
            };
        });

        // Agrupación de productos por categoría y cálculo de sumatorias
        const categoriaTotales = {};
        data.forEach((item) => {
            if (!categoriaTotales[item.categoria]) {
                categoriaTotales[item.categoria] = 0;
            }
            categoriaTotales[item.categoria] += item.totalPrendas; // Ir sumando las tallas por categoría
        });

        // Crear texto para mostrar las sumatorias por categoría
        let lineaCategorias = 20; // Coordenada vertical inicial para las categorías (justo debajo del título y la fecha)
        pdf.setFontSize(11); // Ajustar el tamaño de fuente para que sea más pequeño
        Object.entries(categoriaTotales).forEach(([categoria, total]) => {
            pdf.text(`${categoria}: ${total} piezas`, 10, lineaCategorias);
            lineaCategorias += 7; // Espaciado entre líneas
        });

        // Calcular la sumatoria global de todas las prendas
        const totalGlobal = data.reduce((acc, row) => acc + row.totalPrendas, 0);

        // Mostrar el total global justo debajo de las categorías
        pdf.text(`Total global: ${totalGlobal} piezas`, 10, lineaCategorias);

        // Iniciar tabla un poco más abajo para evitar superposición
        const startY = lineaCategorias + 10; // Ajusta la posición inicial según la cantidad de categorías
        pdf.autoTable({
            startY,
            head: [columns.map((col) => col.title)],
            body: data.map((item) => Object.values(item)),
            didDrawCell: async (data) => {
                if (data.column.index === 1 && data.cell.section === 'body') {
                    const producto = productosFiltrados[data.row.index];
                    if (producto?.imagen1) {
                        try {
                            // Tamaño de la celda
                            const cellWidth = data.cell.width;
                            const cellHeight = data.cell.height;

                            // Tamaño de la imagen (ajustar para que quepa en la celda)
                            const imgWidth = cellWidth - 2; // Margen pequeño
                            const imgHeight = cellHeight - 2;

                            // Posición (centrada en la celda)
                            const x = data.cell.x + (cellWidth - imgWidth) / 2;
                            const y = data.cell.y + (cellHeight - imgHeight) / 2;

                            // Agregar la imagen
                            pdf.addImage(
                                await getBase64ImageFromUrl(producto?.imagen1),
                                'JPEG', // o 'PNG' según corresponda
                                x,
                                y,
                                imgWidth,
                                imgHeight
                            );
                        } catch (error) {
                            console.error('Error al cargar la imagen:', error);
                            pdf.text('Imagen no disponible', data.cell.x + 2, data.cell.y + 5);
                        }
                    }
                }
            },
        });

        // Guardar el PDF
        pdf.save("productos.pdf");
    };

    const descargarPDFConImagenes = async () => {
        setIsExporting(true);
        setExportProgress(0);
        setExportTotal(productosFiltrados.length);

        try {
            const pdf = new jsPDF({ orientation: 'landscape' });
            const titulo = "Lista de Productos con Imágenes";
            const fecha = `Fecha de reporte: ${new Date().toISOString().split("T")[0]}`;

            // Configuración de imágenes
            const IMG_WIDTH_DESEADO = 18;
            const PADDING = 2;
            const MIN_ROW_HEIGHT = 20;
            const COL_WIDTH = IMG_WIDTH_DESEADO + (PADDING * 2);

            // Agregar título y fecha
            pdf.text(titulo, 10, 10);
            const pageWidth = pdf.internal.pageSize.getWidth();
            const fechaWidth = pdf.getTextWidth(fecha);
            const fechaX = pageWidth - fechaWidth - 10;
            pdf.text(fecha, fechaX, 10);

            // Pre-cargar todas las imágenes con progreso
            const imagePromises = productosFiltrados.map((producto, index) => {
                if (producto.imagen1) {
                    return getBase64ImageFromUrl(producto.imagen1)
                        .then(img => {
                            setExportProgress(index + 1);
                            return img;
                        })
                        .catch(() => null);
                }
                setExportProgress(index + 1);
                return Promise.resolve(null);
            });

            const images = await Promise.all(imagePromises);

            // Calcular alturas de fila basadas en las imágenes
            const rowHeights = images.map(img => {
                if (img && img.width && img.height) {
                    const ratio = img.height / img.width;
                    const calculatedHeight = IMG_WIDTH_DESEADO * ratio;
                    return Math.max(calculatedHeight + (PADDING * 2), MIN_ROW_HEIGHT);
                }
                return MIN_ROW_HEIGHT;
            });

            // Preparar datos
            const data = productosFiltrados.map((item, index) => {
                const total =
                    Number(item.stockItem1 || 0) +
                    Number(item.stockItem2 || 0) +
                    Number(item.stockItem3 || 0) +
                    Number(item.stockItem4 || 0) +
                    Number(item.stockItem5 || 0);

                return [
                    item.idProducto,
                    '', // Espacio para imagen
                    item.titulo.slice(0, 20),
                    item.descripcion.slice(0, 20),
                    `$${item.precio}`,
                    item.categoria || "-",
                    item.stockItem1 || 0,
                    item.stockItem2 || 0,
                    item.stockItem3 || 0,
                    item.stockItem4 || 0,
                    item.stockItem5 || 0,
                    total,
                    item.modulo || "-",
                    item.nivel || "-"
                ];
            });

            // Crear tabla con imágenes
            // Dividir productos en grupos de 6 por página
            const PRODUCTOS_POR_PAGINA = 6;
            let currentPageNum = 0;
            
            for (let i = 0; i < data.length; i += PRODUCTOS_POR_PAGINA) {
                if (currentPageNum > 0) {
                    pdf.addPage();
                    // Agregar título y fecha en cada página
                    pdf.text(titulo, 10, 10);
                    pdf.text(fecha, fechaX, 10);
                }
                
                const pageData = data.slice(i, i + PRODUCTOS_POR_PAGINA);
                const pageImages = images.slice(i, i + PRODUCTOS_POR_PAGINA);
                const pageHeights = rowHeights.slice(i, i + PRODUCTOS_POR_PAGINA);
                
                pdf.autoTable({
                    startY: 20,
                    head: [[
                        'ID', 'IMAGEN', 'TÍTULO', 'DESCRIPCIÓN', 'PRECIO', 'CATEGORÍA',
                        'Ch', 'M', 'G', 'Xg', 'Xxg', 'Total', 'MODULO', 'NIVEL'
                    ]],
                    body: pageData,
                    headStyles: {
                        fontSize: 8,
                        textColor: [255, 255, 255],
                        fillColor: [41, 128, 185],
                        cellPadding: 0.5,
                        halign: 'center'
                    },
                    styles: {
                        fontSize: 7,
                        cellPadding: 2,
                        valign: 'middle',
                        halign: 'center',
                        overflow: 'visible'
                    },
                    columnStyles: {
                        0: { cellWidth: 12 },
                        1: { cellWidth: COL_WIDTH },
                        2: { cellWidth: 35 },
                        3: { cellWidth: 35 },
                        6: { fontSize: 12 },  // Ch
                        7: { fontSize: 12 },  // M
                        8: { fontSize: 12 },  // G
                        9: { fontSize: 12 },  // Xg
                        10: { fontSize: 12 }, // Xxg
                        11: { fontSize: 12 }, // Total
                        12: { fontSize: 12 }, // MODULO
                        13: { fontSize: 12 }, // NIVEL
                    },
                    didParseCell: function(data) {
                        if (data.section === 'body') {
                            const uniqueRowHeight = pageHeights[data.row.index];
                            if (uniqueRowHeight) data.row.height = uniqueRowHeight;
                        }
                    },
                    didDrawCell: (data) => {
                        if (data.column.index === 1 && data.cell.section === 'body') {
                            const imgData = pageImages[data.row.index];
                            if (imgData) {
                                const w = IMG_WIDTH_DESEADO;
                                const h = w * (imgData.height / imgData.width);
                                const x = data.cell.x + (data.cell.width - w) / 2;
                                const yImg = data.cell.y + (data.cell.height - h) / 2;
                                pdf.addImage(imgData.dataURL, 'PNG', x, yImg, w, h);
                            }
                        }
                    }
                });
                
                currentPageNum++;
            }

            pdf.save('productos_con_imagenes.pdf');
            toast.success('PDF exportado exitosamente');
        } catch (error) {
            console.error('Error al exportar PDF:', error);
            toast.error('Error al exportar PDF con imágenes');
        } finally {
            setIsExporting(false);
            setExportProgress(0);
        }
    };


const contarImagenes = (item) =>
        [item.imagen1, item.imagen2, item.imagen3, item.imagen4].filter(Boolean).length;

    const invertirOrden = () => {
        setProductos([...productos].reverse());
        setOrdenInvertido(!ordenInvertido);
    };


    const handleUpdateText = (idProducto) => {
        // Validar campos obligatorios
        const nuevosErrores = {};
        
        if (!nuevoTitulo || nuevoTitulo.trim() === '') {
            nuevosErrores.titulo = 'El título es obligatorio';
        }
        
        if (!nuevoPrecio || nuevoPrecio <= 0) {
            nuevosErrores.precio = 'El precio es obligatorio y debe ser mayor a 0';
        }
        
        if (!nuevaCategoria || nuevaCategoria === '') {
            nuevosErrores.categoria = 'La categoría es obligatoria';
        }
        
        if (!nuevoMasVendido || nuevoMasVendido === '') {
            nuevosErrores.masVendido = 'El campo "Más vendido" es obligatorio';
        }
        
        if (!nuevoEsAccesorio || nuevoEsAccesorio === '') {
            nuevosErrores.esAccesorio = 'El campo "Es accesorio" es obligatorio';
        }

        // Si hay errores, mostrarlos y no continuar
        if (Object.keys(nuevosErrores).length > 0) {
            setErrores(nuevosErrores);
            toast.error('Por favor, complete todos los campos obligatorios');
            return;
        }

        // Limpiar errores si todo está bien
        setErrores({});

        const payload = {
            nuevoTitulo: nuevoTitulo !== '' ? nuevoTitulo : producto.titulo,
            nuevaDescripcion: nuevaDescripcion !== undefined ? nuevaDescripcion : producto.descripcion,
            nuevoPrecio: nuevoPrecio !== '' ? nuevoPrecio : producto.precio,
            nuevaCategoria: nuevaCategoria !== '' ? nuevaCategoria : producto.idCategoria,
            esAccesorio: nuevoEsAccesorio !== '' ? nuevoEsAccesorio : producto.esAccesorio,
            masVendido: nuevoMasVendido !== '' ? nuevoMasVendido : producto.masVendido,
            visible: nuevoVisible !== undefined ? nuevoVisible : producto.visible,
            item1: item1 !== undefined ? item1 : producto.item1,
            item2: item2 !== undefined ? item2 : producto.item2,
            item3: item3 !== undefined ? item3 : producto.item3,
            item4: item4 !== undefined ? item4 : producto.item4,
            item5: item5 !== undefined ? item5 : producto.item5,
            precioAnterior: nuevoPrecioAnterior !== 0 ? nuevoPrecioAnterior : producto.precioAnterior,
            stockItem1: stockItem1 !== undefined ? stockItem1 : producto.stockItem1,
            stockItem2: stockItem2 !== undefined ? stockItem2 : producto.stockItem2,
            stockItem3: stockItem3 !== undefined ? stockItem3 : producto.stockItem3,
            stockItem4: stockItem4 !== undefined ? stockItem4 : producto.stockItem4,
            stockItem5: stockItem5 !== undefined ? stockItem5 : producto.stockItem5,
            modulo: modulo !== '' ? modulo : producto.modulo,
            nivel: nivel !== '' ? nivel : producto.nivel,
        };

        adminFetch(`${baseURL}/api/admin/productos/${idProducto}/texto`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {

                    Swal.fire(
                        'Error!',
                        data.error,
                        'error'
                    );
                } else {

                    Swal.fire(
                        'Editado!',
                        data.mensaje,
                        'success'
                    );
                    cargarProductos();
                    cerrarModal()
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
    };

    const handleFileChange = async (event, setFile, setPreview, imageNumber = '') => {
        const file = event.target.files[0];

        if (file) {
            try {
                // Mostrar mensaje de procesamiento
                toast.info('Comprimiendo imagen a WebP...', { autoClose: 1000 });
                
                // Comprimir y convertir a WebP
                const compressedWebP = await compressImageToWebP(file, {
                    quality: 0.82, // 82% de calidad
                    maxWidthOrHeight: 2000 // Máximo 2000px en cualquier dimensión
                });
                
                // Crear preview del archivo comprimido
                const previewURL = URL.createObjectURL(compressedWebP);
                setFile(compressedWebP);
                setPreview(previewURL);
                
                // Mostrar información de compresión
                const originalSize = (file.size / 1024).toFixed(2);
                const compressedSize = (compressedWebP.size / 1024).toFixed(2);
                const reduction = ((1 - compressedWebP.size / file.size) * 100).toFixed(1);
                
                toast.success(
                    `✓ Imagen ${imageNumber} optimizada: ${originalSize}KB → ${compressedSize}KB (${reduction}% reducción)`,
                    { autoClose: 3000 }
                );
            } catch (error) {
                console.error('Error al comprimir imagen:', error);
                toast.error(`Error al procesar imagen ${imageNumber}: ${error.message}`);
            }
        }
    };
    const handleEditarImagenBanner = (idProducto) => {
        const formData = new FormData();

        if (nuevaImagen) {
            formData.append('imagen1', nuevaImagen);
        }
        if (nuevaImagen2) {
            formData.append('imagen2', nuevaImagen2);
        }
        if (nuevaImagen3) {
            formData.append('imagen3', nuevaImagen3);
        }
        if (nuevaImagen4) {
            formData.append('imagen4', nuevaImagen4);
        }

        adminFetch(`${baseURL}/api/admin/productos/${idProducto}/imagen`, {
            method: 'POST',
            body: formData
        })
            .then(response => {
                // Manejar el caso cuando la respuesta no es un JSON válido o está vacía
                if (!response.ok) {
                    throw new Error('La solicitud no fue exitosa');

                }

                return response.json();
            })
            .then(data => {
                if (data.error) {

                    toast.error(data.error);
                } else {

                    toast.success(data.mensaje);
                    window.location.reload();
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
    };

    const handleEsAccesorioChange = (e) => {
        setNuevoEsAccesorio(e.target.value);
        if (e.target.value == "si") {
            setViewAllSizes(false);
        } else {
            setViewAllSizes(true);
        }
    };

    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };

    useEffect(() => {
        cargarCategoria();
    }, []);


    const cargarCategoria = () => {
        fetch(`${baseURL}/api/categorias`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategoras(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cambiarOrden = (idProducto1, idProducto2, nuevoOrden1, nuevoOrden2) => {
        adminFetch(`${baseURL}/api/admin/productos/orden`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                idProducto1,
                idProducto2,
                nuevoOrden1,
                nuevoOrden2
            }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    toast.error(data.error);
                } else {
                    toast.success(data.mensaje);
                    // Recargar pero mantener la página actual
                    const paginaActual = currentPage;
                    cargarProductos();
                    // Restaurar la página después de un pequeño delay
                    setTimeout(() => {
                        setCurrentPage(paginaActual);
                    }, 100);
                }
            })
            .catch(error => {
                console.error('Error al cambiar el orden:', error);
                toast.error('Error al cambiar el orden del producto');
            });
    };

    const getOrdenValue = (item, idx) => {
        // Si no viene "orden" desde backend, usa idProducto o posición como fallback
        if (item?.orden !== undefined && item?.orden !== null && item?.orden !== '') return Number(item.orden);
        if (item?.idProducto) return Number(item.idProducto);
        return idx + 1;
    };

    const moverArriba = (productoItem) => {
        // Encontrar el índice real del producto en el array completo filtrado
        const indexReal = productosFiltrados.findIndex(p => p.idProducto === productoItem.idProducto);
        if (indexReal === 0) return; // No se puede mover hacia arriba si es el primero
        
        const productoAnterior = productosFiltrados[indexReal - 1];
        const ordenActual = getOrdenValue(productoItem, indexReal);
        const ordenAnterior = getOrdenValue(productoAnterior, indexReal - 1);
        cambiarOrden(productoItem.idProducto, productoAnterior.idProducto, ordenAnterior, ordenActual);
    };

    const moverAbajo = (productoItem) => {
        // Encontrar el índice real del producto en el array completo filtrado
        const indexReal = productosFiltrados.findIndex(p => p.idProducto === productoItem.idProducto);
        if (indexReal === productosFiltrados.length - 1) return; // No se puede mover hacia abajo si es el último
        
        const productoSiguiente = productosFiltrados[indexReal + 1];
        const ordenActual = getOrdenValue(productoItem, indexReal);
        const ordenSiguiente = getOrdenValue(productoSiguiente, indexReal + 1);
        cambiarOrden(productoItem.idProducto, productoSiguiente.idProducto, ordenSiguiente, ordenActual);
    };

    return (
        <div>

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss={false}
                draggable={false}
                pauseOnHover={false}
                theme="light"
            />
            <div className='deFlexContent'>

                <div className='deFlex2'>
                    <NewProduct />
                    <button className='excel' onClick={descargarExcel}><FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                    <button className='pdf' onClick={descargarPDF}><FontAwesomeIcon icon={faArrowDown} /> PDF</button>
                    <button className='excel' onClick={descargarPDFConImagenes} disabled={isExporting}>
                        <FontAwesomeIcon icon={faArrowDown} /> {isExporting ? 'Exportando...' : 'PDF con imágenes'}
                    </button>
                    <button className='importar' onClick={() => setModalImportacionVisible(true)}><FontAwesomeIcon icon={faUpload} /> Importar</button>
                </div>
                <div className='filtrosContain'>
                    <div className='inputsColumn'>
                        <input type="number" value={filtroId} onChange={(e) => setFiltroId(e.target.value)} placeholder='Id Producto' />
                    </div>

                    <div className='inputsColumn'>
                        <input type="text" value={filtroTitulo} onChange={(e) => setFiltroTitulo(e.target.value)} placeholder='Titulo' />
                    </div>

                    <div className='inputsColumn'>
                        <select value={filtroCategoria} onChange={(e) => {
                            setFiltroCategoria(e.target.value);
                            paginate(1)
                        }}>
                            <option value="">Categorias</option>
                            {
                                categorias.map(item => (
                                    <option key={item.idCategoria} value={item?.idCategoria}>{item?.categoria}</option>
                                ))
                            }
                        </select>
                    </div>

<button className='reverse' onClick={invertirOrden}>
                        {ordenInvertido ? <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faArrowDown} />}
                    </button>

                </div>

            </div>


            {modalImagenVisible && (
                <div className="modalImg">
                    <div className="modal-contentImg">


                        <span className="close2" onClick={cerrarModalImagen}>
                            &times;
                        </span>

                        <img src={imagenSeleccionada} alt="Imagen Seleccionada" />
                    </div>
                </div>
            )}

            {modalVisible && (
                <div className="modal product-edit-modal">
                    <div className="modal-content product-edit-modal-content">
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Editar Producto</button>
                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        
                        <div className='flexGrap'>
                                <fieldset className={`required-field ${errores.titulo ? 'fieldset-error' : ''}`}>
                                    <legend>Título</legend>
                                    <input
                                        type="text"
                                        value={nuevoTitulo !== '' ? nuevoTitulo : producto.titulo}
                                        onChange={(e) => setNuevoTitulo(e.target.value)}
                                    />
                                    {errores.titulo && <div className="error-message">{errores.titulo}</div>}
                                </fieldset>
                                <fieldset className={`required-field ${errores.precio ? 'fieldset-error' : ''}`}>
                                    <legend>Precio</legend>
                                    <input
                                        type="number"
                                        value={nuevoPrecio !== '' ? nuevoPrecio : producto.precio}
                                        onChange={(e) => setNuevoPrecio(e.target.value)}
                                    />
                                    {errores.precio && <div className="error-message">{errores.precio}</div>}
                                </fieldset>
                                <fieldset id='descripcion'>
                                    <legend>Descripción</legend>
                                    <textarea
                                        type="text"
                                        value={nuevaDescripcion}
                                        onChange={(e) => setNuevaDescripcion(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset className={`required-field ${errores.categoria ? 'fieldset-error' : ''}`}>
                                    <legend>Categoria</legend>
                                    <select
                                        value={nuevaCategoria !== '' ? nuevaCategoria : producto.categoria}
                                        onChange={(e) => setNuevaCategoria(e.target.value)}
                                    >

                                        {
                                            categorias
                                                .filter(categoriaFiltrada => categoriaFiltrada.idCategoria === producto.idCategoria)
                                                .map(categoriaFiltrada => (

                                                    <option value={producto.categoria}> {categoriaFiltrada.categoria}</option>
                                                ))
                                        }

                                        {
                                            categorias.map(item => (
                                                <option value={item?.idCategoria}>{item?.categoria}</option>
                                            ))
                                        }
                                    </select>
                                    {errores.categoria && <div className="error-message">{errores.categoria}</div>}
                                </fieldset>

                                <fieldset className={`required-field ${errores.esAccesorio ? 'fieldset-error' : ''}`}>
                                    <legend>es Accesorio</legend>
                                    <select
                                        value={nuevoEsAccesorio !== '' ? nuevoEsAccesorio : producto.esAccesorio}
                                        onChange={handleEsAccesorioChange}
                                    >
                                        <option value="">Selecciona opción</option>
                                        <option value="si">Si</option>
                                        <option value="no">No</option>
                                    </select>
                                    {errores.esAccesorio && <div className="error-message">{errores.esAccesorio}</div>}
                                </fieldset>

                                <fieldset className={`required-field ${errores.masVendido ? 'fieldset-error' : ''}`}>
                                    <legend>Más vendido</legend>
                                    <select
                                        value={nuevoMasVendido !== '' ? nuevoMasVendido : producto.masVendido}
                                        onChange={(e) => setNuevoMasVendido(e.target.value)}
                                    >
                                        <option value="">Selecciona opción</option>
                                        <option value="si">Si</option>
                                        <option value="no">No</option>
                                    </select>
                                    {errores.masVendido && <div className="error-message">{errores.masVendido}</div>}
                                </fieldset>

                                <fieldset>
                                    <legend>Visible al público</legend>
                                    <select
                                        value={nuevoVisible !== undefined ? nuevoVisible : (producto.visible !== undefined ? producto.visible : '1')}
                                        onChange={(e) => setNuevoVisible(e.target.value)}
                                    >
                                        <option value="1">Sí (Mostrar)</option>
                                        <option value="0">No (Ocultar)</option>
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Precio anterior</legend>
                                    <input
                                        type="number"
                                        value={nuevoPrecioAnterior !== '' ? nuevoPrecioAnterior : producto.precioAnterior}
                                        onChange={(e) => setNuevoPrecioAnterior(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Módulo</legend>
                                    <input
                                        type="text"
                                        id="modulo"
                                        name="modulo"
                                        value={modulo !== '' ? modulo : producto.modulo}
                                        onChange={(e) => setNuevoModulo(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Nivel</legend>
                                    <input
                                        type="text"
                                        id="nivel"
                                        name="nivel"
                                        value={nivel !== '' ? nivel : producto.nivel}
                                        onChange={(e) => setNuevoNivel(e.target.value)}
                                    />
                                </fieldset>
                                <div className='items'>
                                    <fieldset>
                                        <legend>Talla 1</legend>
                                        <input
                                            type="text"
                                            id="item1"
                                            name="item1"
                                            required
                                            value={item1}
                                            onChange={(e) => setItem1(e.target.value)}
                                            disabled
                                        />
                                    </fieldset>
                                    <fieldset>
                                        <legend>Cant 1</legend>
                                        <input
                                            type="number"
                                            id="stockItem1"
                                            name="stockItem1"
                                            required
                                            value={stockItem1}
                                            onChange={(e) => setStockItem1(e.target.value)}
                                        />
                                    </fieldset>

                                    {viewAllSizes && (
                                        <>
                                            <fieldset>
                                                <legend>Talla 2</legend>
                                                <input
                                                    type="text"
                                                    id="item2"
                                                    name="item2"
                                                    required
                                                    value={item2}
                                                    onChange={(e) => setItem2(e.target.value)}
                                                    disabled
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Cant 2</legend>
                                                <input
                                                    type="number"
                                                    id="stockItem2"
                                                    name="stockItem2"
                                                    required
                                                    value={stockItem2}
                                                    onChange={(e) => setStockItem2(e.target.value)}
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Talla 3</legend>
                                                <input
                                                    type="text"
                                                    id="item3"
                                                    name="item3"
                                                    required
                                                    value={item3}
                                                    onChange={(e) => setItem3(e.target.value)}
                                                    disabled
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Cant 3</legend>
                                                <input
                                                    type="number"
                                                    id="stockItem3"
                                                    name="stockItem3"
                                                    required
                                                    value={stockItem3}
                                                    onChange={(e) => setStockItem3(e.target.value)}
                                                />
                                            </fieldset>

                                            <fieldset>
                                                <legend>Talla 4</legend>
                                                <input
                                                    type="text"
                                                    id="item4"
                                                    name="item4"
                                                    required
                                                    value={item4}
                                                    onChange={(e) => setItem4(e.target.value)}
                                                    disabled
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Cant 4</legend>
                                                <input
                                                    type="number"
                                                    id="stockItem4"
                                                    name="stockItem4"
                                                    required
                                                    value={stockItem4}
                                                    onChange={(e) => setStockItem4(e.target.value)}
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Talla 5</legend>
                                                <input
                                                    type="text"
                                                    id="item5"
                                                    name="item5"
                                                    required
                                                    value={item5}
                                                    onChange={(e) => setItem5(e.target.value)}
                                                    disabled
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Cant 5</legend>
                                                <input
                                                    type="number"
                                                    id="stockItem5"
                                                    name="stockItem5"
                                                    required
                                                    value={stockItem5}
                                                    onChange={(e) => setStockItem5(e.target.value)}
                                                />
                                            </fieldset>
                                        </>
                                    )}
                                </div>
                            
                            {/* SECCIÓN DE IMÁGENES CON NUEVO DISEÑO */}
                            <div className='images-upload-section'>
                                <span className='section-title'>Imágenes del Producto</span>
                                <div className='images-grid'>
                                    {/* Imagen 1 */}
                                    <div className='image-upload-item'>
                                        <div className='preview-box-small' onClick={() => fileInputRef1.current.click()}>
                                            {imagenPreview ? (
                                                <img src={imagenPreview} alt="Imagen 1" className='img-preview-full' />
                                            ) : producto.imagen1 ? (
                                                <img src={producto.imagen1} alt="Imagen 1" className='img-preview-full' />
                                            ) : (
                                                <div className='placeholder-content-small'>
                                                    <FontAwesomeIcon icon={faImage} size="lg" />
                                                    <span>1</span>
                                                </div>
                                            )}
                                        </div>
                                        <input 
                                            type="file" 
                                            accept="image/*"
                                            ref={fileInputRef1}
                                            style={{ display: 'none' }}
                                            onChange={(e) => handleFileChange(e, setNuevaImagen, setImagenPreview, 1)}
                                        />
                                        <button type="button" className='btn-upload-small' onClick={() => fileInputRef1.current.click()}>
                                            <FontAwesomeIcon icon={faUpload} /> {imagenPreview || producto.imagen1 ? 'Cambiar' : 'Subir'}
                                        </button>
                                    </div>

                                    {/* Imagen 2 */}
                                    <div className='image-upload-item'>
                                        <div className='preview-box-small' onClick={() => fileInputRef2.current.click()}>
                                            {imagenPreview2 ? (
                                                <img src={imagenPreview2} alt="Imagen 2" className='img-preview-full' />
                                            ) : producto.imagen2 ? (
                                                <img src={producto.imagen2} alt="Imagen 2" className='img-preview-full' />
                                            ) : (
                                                <div className='placeholder-content-small'>
                                                    <FontAwesomeIcon icon={faImage} size="lg" />
                                                    <span>2</span>
                                                </div>
                                            )}
                                        </div>
                                        <input 
                                            type="file" 
                                            accept="image/*"
                                            ref={fileInputRef2}
                                            style={{ display: 'none' }}
                                            onChange={(e) => handleFileChange(e, setNuevaImagen2, setImagenPreview2, 2)}
                                        />
                                        <button type="button" className='btn-upload-small' onClick={() => fileInputRef2.current.click()}>
                                            <FontAwesomeIcon icon={faUpload} /> {imagenPreview2 || producto.imagen2 ? 'Cambiar' : 'Subir'}
                                        </button>
                                    </div>

                                    {/* Imagen 3 */}
                                    <div className='image-upload-item'>
                                        <div className='preview-box-small' onClick={() => fileInputRef3.current.click()}>
                                            {imagenPreview3 ? (
                                                <img src={imagenPreview3} alt="Imagen 3" className='img-preview-full' />
                                            ) : producto.imagen3 ? (
                                                <img src={producto.imagen3} alt="Imagen 3" className='img-preview-full' />
                                            ) : (
                                                <div className='placeholder-content-small'>
                                                    <FontAwesomeIcon icon={faImage} size="lg" />
                                                    <span>3</span>
                                                </div>
                                            )}
                                        </div>
                                        <input 
                                            type="file" 
                                            accept="image/*"
                                            ref={fileInputRef3}
                                            style={{ display: 'none' }}
                                            onChange={(e) => handleFileChange(e, setNuevaImagen3, setImagenPreview3, 3)}
                                        />
                                        <button type="button" className='btn-upload-small' onClick={() => fileInputRef3.current.click()}>
                                            <FontAwesomeIcon icon={faUpload} /> {imagenPreview3 || producto.imagen3 ? 'Cambiar' : 'Subir'}
                                        </button>
                                    </div>

                                    {/* Imagen 4 */}
                                    <div className='image-upload-item'>
                                        <div className='preview-box-small' onClick={() => fileInputRef4.current.click()}>
                                            {imagenPreview4 ? (
                                                <img src={imagenPreview4} alt="Imagen 4" className='img-preview-full' />
                                            ) : producto.imagen4 ? (
                                                <img src={producto.imagen4} alt="Imagen 4" className='img-preview-full' />
                                            ) : (
                                                <div className='placeholder-content-small'>
                                                    <FontAwesomeIcon icon={faImage} size="lg" />
                                                    <span>4</span>
                                                </div>
                                            )}
                                        </div>
                                        <input 
                                            type="file" 
                                            accept="image/*"
                                            ref={fileInputRef4}
                                            style={{ display: 'none' }}
                                            onChange={(e) => handleFileChange(e, setNuevaImagen4, setImagenPreview4, 4)}
                                        />
                                        <button type="button" className='btn-upload-small' onClick={() => fileInputRef4.current.click()}>
                                            <FontAwesomeIcon icon={faUpload} /> {imagenPreview4 || producto.imagen4 ? 'Cambiar' : 'Subir'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='modal-footer-actions'>
                            <button className='btnPost' onClick={() => {
                                handleUpdateText(producto.idProducto);
                                if (nuevaImagen || nuevaImagen2 || nuevaImagen3 || nuevaImagen4) {
                                    handleEditarImagenBanner(producto.idProducto);
                                }
                            }}>Guardar</button>
                            <button className='btnCancelar' onClick={cerrarModal}>Cancelar</button>
                        </div>

                    </div>
                </div>
            )}
            {/* ── TABLA (desktop) ── */}
            <div className='table-container prod-desktop-table'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>SKU</th>
                            <th>Titulo</th>
                            <th>Precio</th>
                            <th>Categoria</th>
                            <th>Img 1</th>
                            <th>Img 2</th>
                            <th>Img 3</th>
                            <th>Img 4</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            Array.from({ length: itemsPerPage }).map((_, idx) => (
                                <tr key={`skeleton-${idx}`} className="skeleton-row">
                                    <td><span className="skeleton-block" /></td>
                                    <td><span className="skeleton-block" /></td>
                                    <td><span className="skeleton-block" /></td>
                                    <td><span className="skeleton-block" /></td>
                                    <td><span className="skeleton-block skeleton-img" /></td>
                                    <td><span className="skeleton-block skeleton-img" /></td>
                                    <td><span className="skeleton-block skeleton-img" /></td>
                                    <td><span className="skeleton-block skeleton-img" /></td>
                                    <td><span className="skeleton-block" /></td>
                                </tr>
                            ))
                        ) : (
                            currentItems.map((item) => (
                                <tr key={item.idProducto}>
                                    <td>{item.idProducto}</td>
                                    <td>{item.titulo}</td>
                                    <td style={{ color: '#008000' }}>
                                        {moneda} {`${item?.precio}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                    </td>
                                    <td style={{ color: '#DAA520' }}>
                                        {item.categoria || categorias.find(c => c.idCategoria == item.idCategoria)?.categoria || '-'}
                                    </td>
                                    <td>
                                        <div className="img-count-wrapper">
                                            <ImageWithSkeleton src={item.imagen1} alt="imagen1" />
                                            <span className={`prod-img-badge ${contarImagenes(item) === 0 ? 'prod-img-badge--none' : ''}`}>
                                                {contarImagenes(item) === 0 ? '0' : `${contarImagenes(item)}/4`}
                                            </span>
                                        </div>
                                    </td>
                                    <td><ImageWithSkeleton src={item.imagen2} alt="imagen2" /></td>
                                    <td><ImageWithSkeleton src={item.imagen3} alt="imagen3" /></td>
                                    <td><ImageWithSkeleton src={item.imagen4} alt="imagen4" /></td>
                                    <td>
                                        <div className='acciones-container'>
                                            {filtroCategoria !== '' && <>
                                                <button onClick={() => moverArriba(item)} className='accion-control-btn'><FontAwesomeIcon icon={faChevronUp} /></button>
                                                <button onClick={() => moverAbajo(item)} className='accion-control-btn'><FontAwesomeIcon icon={faChevronDown} /></button>
                                            </>}
                                            <button className='btn-eliminar' onClick={() => eliminarProducto(item.idProducto)}><FontAwesomeIcon icon={faTrash} /></button>
                                            <button className='btn-editar' onClick={() => abrirModal(item)}><FontAwesomeIcon icon={faEdit} /></button>
                                            <Anchor className='btn-ver' to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`}><FontAwesomeIcon icon={faEye} /></Anchor>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* ── TARJETAS (móvil) ── */}
            <div className='prod-mobile-list'>
                {loading ? (
                    Array.from({ length: 4 }).map((_, idx) => (
                        <div key={idx} className='prod-card-skeleton'>
                            <span className="skeleton-block skeleton-img" style={{ width: 72, height: 72, borderRadius: 8, flexShrink: 0 }} />
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
                                <span className="skeleton-block" style={{ height: 14, width: '80%' }} />
                                <span className="skeleton-block" style={{ height: 12, width: '40%' }} />
                                <span className="skeleton-block" style={{ height: 12, width: '55%' }} />
                            </div>
                        </div>
                    ))
                ) : (
                    currentItems.map((item) => (
                        <div key={item.idProducto} className='prod-card'>
                            <div className='prod-card-top'>
                                <div className='prod-card-img'>
                                    <ImageWithSkeleton src={item.imagen1} alt={item.titulo} />
                                    <span className={`prod-img-badge ${contarImagenes(item) === 0 ? 'prod-img-badge--none' : ''}`}>
                                        {contarImagenes(item) === 0 ? 'Sin imgs' : `${contarImagenes(item)}/4`}
                                    </span>
                                </div>
                                <div className='prod-card-info'>
                                    <span className='prod-card-titulo'>{item.titulo}</span>
                                    <span className='prod-card-precio'>{moneda} {`${item?.precio}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</span>
                                    <span className='prod-card-cat'>{item.categoria || categorias.find(c => c.idCategoria == item.idCategoria)?.categoria || '—'}</span>
                                    <span className='prod-card-sku'>SKU #{item.idProducto}</span>
                                </div>
                            </div>
                            <div className='prod-card-actions'>
                                {filtroCategoria !== '' && <>
                                    <button className='accion-control-btn' onClick={() => moverArriba(item)}><FontAwesomeIcon icon={faChevronUp} /></button>
                                    <button className='accion-control-btn' onClick={() => moverAbajo(item)}><FontAwesomeIcon icon={faChevronDown} /></button>
                                </>}
                                <button className='prod-card-btn prod-card-btn--del' onClick={() => eliminarProducto(item.idProducto)}>
                                    <FontAwesomeIcon icon={faTrash} /> Eliminar
                                </button>
                                <button className='prod-card-btn prod-card-btn--edit' onClick={() => abrirModal(item)}>
                                    <FontAwesomeIcon icon={faEdit} /> Editar
                                </button>
                                <Anchor className='prod-card-btn prod-card-btn--ver' to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`}>
                                    <FontAwesomeIcon icon={faEye} /> Ver
                                </Anchor>
                            </div>
                        </div>
                    ))
                )}
            </div>
            {/* Componente de paginación */}
            <div className="pagination">
                <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                    &laquo;
                </button>

                {(() => {
                    const totalPages = Math.ceil(productosFiltrados.length / itemsPerPage);
                    const pages = [];
                    const delta = 2;
                    const range = [];
                    for (let i = Math.max(2, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) {
                        range.push(i);
                    }
                    pages.push(1);
                    if (range[0] > 2) pages.push('...');
                    pages.push(...range);
                    if (range[range.length - 1] < totalPages - 1) pages.push('...');
                    if (totalPages > 1) pages.push(totalPages);

                    return pages.map((p, i) =>
                        p === '...'
                            ? <span key={`dots-${i}`} className="pagination-dots">…</span>
                            : <button key={p} onClick={() => paginate(p)} className={currentPage === p ? 'active' : ''}>{p}</button>
                    );
                })()}

                <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === Math.ceil(productosFiltrados.length / itemsPerPage)}
                >
                    &raquo;
                </button>
            </div>
            
            {/* Componente de Importar Productos */}
            <ImportarProductos 
                modalImportacionVisible={modalImportacionVisible}
                setModalImportacionVisible={setModalImportacionVisible}
                cargarProductos={cargarProductos}
                cargarCategoria={cargarCategoria}
            />
            
            {/* Modal de progreso de exportación */}
            {isExporting && (
                <div className="modal">
                    <div className="modal-content" style={{ maxWidth: '400px', textAlign: 'center' }}>
                        <h3>Exportando productos...</h3>
                        <p>Procesando imágenes: {exportProgress} de {exportTotal}</p>
                        <div style={{
                            width: '100%',
                            height: '30px',
                            backgroundColor: '#e0e0e0',
                            borderRadius: '15px',
                            overflow: 'hidden',
                            marginTop: '20px'
                        }}>
                            <div style={{
                                width: `${(exportProgress / exportTotal) * 100}%`,
                                height: '100%',
                                backgroundColor: '#4caf50',
                                transition: 'width 0.3s ease',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                fontWeight: 'bold'
                            }}>
                                {Math.round((exportProgress / exportTotal) * 100)}%
                            </div>
                        </div>
                        <p style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                            Por favor espera, este proceso puede tardar varios segundos...
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
};
